import { feedbacksConstants } from '../redux-constants'

export function addFeedback(userId, content) {
    return (dispatch, getState, { firestore }) => {
        dispatch(addFeedbackProgress())

        firestore
            .collection('feedbacks')
            .add({
                ownerId: userId,
                content: content,
                date: new Date(),
            })
            .then(() => {
                dispatch(addFeedbackSuccess())
            })
            .catch(error => {
                dispatch(addFeedbackFailure(error.code))
            })
    }
}

function addFeedbackProgress() {
    return {
        type: feedbacksConstants.ADD_FEEDBACK_REQUEST,
    }
}

function addFeedbackSuccess() {
    return {
        type: feedbacksConstants.ADD_FEEDBACK_DONE,
    }
}

function addFeedbackFailure(payload) {
    return {
        type: feedbacksConstants.ADD_FEEDBACK_FAILURE,
        payload: payload,
    }
}
